import { render, staticRenderFns } from "./MobileView.vue?vue&type=template&id=10a0652d"
import script from "./MobileView.vue?vue&type=script&lang=ts"
export * from "./MobileView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports